import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=76d70ca2&scoped=true"
import script from "./BillForm.vue?vue&type=script&lang=js"
export * from "./BillForm.vue?vue&type=script&lang=js"
import style0 from "./BillForm.vue?vue&type=style&index=0&id=76d70ca2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d70ca2",
  null
  
)

export default component.exports